import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import {
  Drone,
  Open,
  Home,
  OrangeIQ,
  RedHS,
  GreenIQ,
  BlueHS,
  GreenHS,
  OrangeHS,
  BlueIQ,
  RedIQ,
  RedMS,
  BlueMS,
  Opening,
} from "./components";
import { Background } from "./background";
import { ThemeProvider } from "./context/themeContext";
import { GreenMS } from "./components/green-ms";
import { OrangeMS } from "./components/orange-ms";

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider>
      <Background>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<App />}>
              <Route path="home" element={<Home />} />

              <Route path="open" element={<Open />} />
              <Route path="drone" element={<Drone />} />

              <Route path="organge-iq" element={<OrangeIQ />} />
              <Route path="green-iq" element={<GreenIQ />} />
              <Route path="red-iq" element={<RedIQ />} />
              <Route path="blue-iq" element={<BlueIQ />} />

              <Route path="red-hs" element={<RedHS />} />
              <Route path="blue-hs" element={<BlueHS />} />
              <Route path="green-hs" element={<GreenHS />} />
              <Route path="orange-hs" element={<OrangeHS />} />

              <Route path="red-ms" element={<RedMS />} />
              <Route path="blue-ms" element={<BlueMS />} />
              <Route path="orange-ms" element={<OrangeMS />} />
              <Route path="green-ms" element={<GreenMS />} />

              <Route path="opening" element={<Opening />} />

              <Route path="/" element={<Navigate to="/home" />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </Background>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
